// Rutas que el rol "admin" del HCE (hce_users, token propio de hce-auth.ts)
// puede efectivamente renderizar SIN sesión de Medplum. Compartida entre
// main.tsx (onUnauthenticated no debe redirigir si ya estamos en una de
// estas) y LandingAcceso.tsx (el login de admin nunca debe aterrizar en otra
// ruta, aunque venga en `next`).
//
// Bug real en vivo 2026-09-13: un admin llegó al login con `?next=/dashboard`
// (arrastrado de una visita vieja a esa página, que exige Medplum). El login
// de admin obedecía `next` a ciegas y la mandaba a /dashboard, que responde
// 401 sin sesión de Medplum y rebota de vuelta a /login?next=/dashboard —
// ping-pong infinito, "Entrar" no llevaba a ningún lado. `next` sigue siendo
// seguro para Personal Médico (esa rama SÍ tiene sesión de Medplum recién
// abierta antes de navegar), así que la restricción es solo para admin.
/** Salida del consultorio: la ÚNICA pantalla del administrador durante el período de descarga (el servidor rechaza todo lo demás). */
export const RUTA_DESCARGAR_HISTORIAS = '/descargar-historias';

export const RUTAS_HCE_ADMIN = ['/usuarios', '/auditoria', '/auditoria/acceso', '/auditoria/checklist', '/comite', '/emergencias', '/alertas', RUTA_DESCARGAR_HISTORIAS] as const;
